/**
 * FIREBASE const symbols.
 * @constant
 * @type {Object}
 */



const FIREBASE = {
    INSTANCE_ID: 'fbInstanceId',
    APP_ID:      'fbAppId'
};


export {FIREBASE};